<template>
  <div class="crud_form_wrapper">
    <!-- Start:: Title -->
    <div class="form_title_wrapper">
      <h4>{{ $t("MESSAGES.Show festival order") }}</h4>
    </div>
    <div class="col-12 text-end">
      <v-btn @click="$router.go(-1)" style="color: #405950">
        <i
          :class="$i18n.locale === 'en' ? 'fas fa-forward' : 'fas fa-backward'"
        ></i>
      </v-btn>
    </div>
    <!-- End:: Title -->

    <!-- Start:: Single Step Form Content -->
    <div class="single_step_form_content_wrapper">
      <form @submit.prevent="validateFormInputs">
        <div class="row">
          <h2>{{ $t("PLACEHOLDERS.showOrder") }}</h2>
          <base-input
            col="4"
            type="text"
            :placeholder="$t('PLACEHOLDERS.orderNum')"
            v-model.trim="data.orderNum"
            disabled
          />
          <base-input
            col="4"
            type="text"
            :placeholder="$t('PLACEHOLDERS.orderCreate')"
            v-model.trim="data.orderCreate"
            disabled
          />
          <base-input
            col="4"
            type="text"
            :placeholder="$t('PLACEHOLDERS.orderStatus')"
            v-model="data.status"
            disabled
          />

          <template v-if="isMultipleTickets">
            <base-input
              col="4"
              type="text"
              :placeholder="$t('MESSAGES.ticketsCount')"
              :value="data.tickets_count"
              disabled
            />
            <base-input
              col="4"
              type="text"
              :placeholder="$t('MESSAGES.ticketsNewCount')"
              :value="data.tickets_new_count"
              disabled
            />
            <base-input
              col="4"
              type="text"
              :placeholder="$t('MESSAGES.ticketsUsedCount')"
              :value="data.tickets_used_count"
              disabled
            />
            <base-input
              col="4"
              type="text"
              :placeholder="$t('MESSAGES.ticketsExpiredCount')"
              :value="data.tickets_expired_count"
              disabled
            />
          </template>

          <div class="col-12" v-if="hasTickets">
            <h2>{{ $t("MESSAGES.orderTickets") }}</h2>
            <div class="tickets_table_wrapper">
              <table class="tickets_table">
                <thead>
                  <tr>
                    <th>{{ $t("TABLES.Admins.serialNumber") }}</th>
                    <th>{{ $t("MESSAGES.ticketSerialNumber") }}</th>
                    <th>{{ $t("MESSAGES.quickCode") }}</th>
                    <th>{{ $t("PLACEHOLDERS.name") }}</th>
                    <th>{{ $t("MESSAGES.childrenCount") }}</th>
                    <th>{{ $t("PLACEHOLDERS.orderStatus") }}</th>
                    <th>{{ $t("MESSAGES.Start date") }}</th>
                    <th>{{ $t("MESSAGES.Entry time (from)") }}</th>
                    <th>{{ $t("MESSAGES.Entry time (to)") }}</th>
                    <th>{{ $t("MESSAGES.Qr") }}</th>
                    <th>{{ $t("MESSAGES.usedAt") }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(ticket, index) in data.tickets"
                    :key="ticket.id || index"
                  >
                    <td>{{ index + 1 }}</td>
                    <td>{{ ticket.serial_number || "-" }}</td>
                    <td>{{ ticket.quick_code || "-" }}</td>
                    <td>{{ ticket.name || "-" }}</td>
                    <td>{{ ticket.childs_count ?? 0 }}</td>
                    <td>{{ ticket._status || ticket.status || "-" }}</td>
                    <td dir="ltr">{{ ticket.festival_date || "-" }}</td>
                    <td dir="ltr">{{ ticket.start_time || "-" }}</td>
                    <td dir="ltr">{{ ticket.end_time || "-" }}</td>
                    <td>
                      <a
                        v-if="ticket.qr_code_url"
                        :href="ticket.qr_code_url"
                        target="_blank"
                        rel="noopener noreferrer"
                        class="ticket_qr_link"
                      >
                        <img
                          :src="ticket.qr_code_url"
                          :alt="ticket.serial_number || 'QR'"
                          class="ticket_qr_image"
                        />
                      </a>
                      <span v-else>-</span>
                    </td>
                    <td dir="ltr">{{ ticket.used_at || "-" }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <h2>{{ $t("PLACEHOLDERS.client_data") }}</h2>
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.clientName')"
            v-model="data.clientName"
            disabled
          />
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.clientPhone')"
            v-model="data.clientPhone"
            disabled
          />

          <h2>{{ $t("MESSAGES.Required product") }}</h2>
          <base-input
            col="4"
            type="text"
            :placeholder="$t('MESSAGES.Festival name')"
            :value="data.festival?.name"
            disabled
          />
          <base-input
            col="4"
            type="text"
            :placeholder="$t('MESSAGES.Center name')"
            :value="data.festival?.festival_provider"
            disabled
          />
          <base-input
            col="4"
            type="text"
            :placeholder="$t('MESSAGES.Festival price')"
            :value="data.festival?.price"
            disabled
          />
          <base-input
            col="4"
            type="text"
            :placeholder="$t('MESSAGES.adultTicketsCount')"
            :value="data.quantity"
            disabled
          />
          <base-input
            col="4"
            type="text"
            :placeholder="$t('MESSAGES.childrenCount')"
            :value="data.children_count"
            disabled
          />
          <div class="m-auto text-center">
            <div>
              <label style="color: #405950; font-size: 16px" class="mb-5">{{
                $t("MESSAGES.Festival image")
              }}</label>
            </div>
            <div>
              <div class="image-preview">
                <img
                  style="width: 200px; height: 200px; object-fit: cover"
                  loading="lazy"
                  :src="data.festival?.image"
                  alt="photo"
                />
              </div>
            </div>
          </div>
          <div class="col-12 my-5">
            <label class="preview-container-label d-block">{{
              $t("PLACEHOLDERS.map_location")
            }}</label>
            <MapComponent
              :lat="parseFloat(data.festival?.lat)"
              :lng="parseFloat(data.festival?.lng)"
            />
          </div>

          <h2>{{ $t("SIDENAV.OrderData.prceDetails") }}</h2>

          <base-input
            col="6"
            type="text"
            :placeholder="$t('MESSAGES.The event price does not include tax')"
            :value="data.payment_details?.sub_total"
            disabled
          />

          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.coupon_code')"
            :value="data.payment_details?.coupon_code || '-'"
            disabled
          />

          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.discountPercentage')"
            :value="
              data.payment_details?.discount_percentage != null
                ? data.payment_details.discount_percentage
                : '-'
            "
            disabled
          />

          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.discountValue')"
            :value="
              data.payment_details?.discount_amount != null
                ? data.payment_details.discount_amount
                : '-'
            "
            disabled
          />

          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.totalTax')"
            :value="data.payment_details?.tax"
            disabled
          />

          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.totalOrderPrice')"
            :value="data.payment_details?.total"
            disabled
          />

          <base-input
            col="6"
            type="text"
            :placeholder="$t('MESSAGES.Center gain')"
            :value="data.payment_details?.festival_provider_profit"
            disabled
          />
          <base-input
            col="6"
            type="text"
            :placeholder="$t('MESSAGES.Application commission from the center')"
            :value="data.payment_details?.app_profit"
            disabled
          />
        </div>
      </form>
    </div>
    <!-- END:: Single Step Form Content -->
  </div>
</template>

<script>
// import RatingPreview from "@/components/ui/RatingPreview.vue";
import RatingPreview from "../../../components/ui/RatingPreview.vue";
import MapComponent from "@/components/general/MapComponent.vue";
export default {
  components: { RatingPreview, MapComponent },
  name: "showFestivalOrder",
  comments: {
    RatingPreview,
  },
  data() {
    return {
      // Start:: Loader Control Data
      isWaitingRequest: false,
      // End:: Loader Control Data

      // Start:: Data Collection To Send
      data: {
        totalePrce: null,
        totalTax: null,
        totalOrderPrice: null,
        discount: null,
        discountValue: null,
        orderPriceAfterDiscount: null,
        comment: null,
        orderNum: null,
        orderCreate: null,
        status: null,
        unit_name: null,
        userName: null,
        userType: null,
        mangement: null,
        secret_number: null,
        products: null,
        serviceName: null,
        servicePrice: null,
        rate: null,
        manegerNmae: null,
        excuteAt: null,
        orderCode: "",
        mainC: null,
        clientName: null,
        back: null,
        clientPhone: null,
        cancelReason: null,
        cancelDate: null,
        address_details: {
          _delivery_type: null,
          address: null,
          lat: null,
          lng: null,
        },
        payment_details: {
          payment_type: null,
          _payment_status: null,
          sub_total: 0,
          delivery_fee: 0,
          tax: 0,
          total: 0,
          festival_provider_profit: 0,
          app_profit: 0,
        },
        festival: {
          name: null,
          festival_provider: null,
          image: null,
          price: null,
          lat: null,
          lng: null,
        },
        ticket_type: null,
        tickets: [],
        tickets_count: null,
        quantity: null,
        children_count: 0,
        tickets_new_count: null,
        tickets_used_count: null,
        tickets_expired_count: null,
        subC: null,
        addServices: null,
        price_additions: null,
        PaymentMethods: null,
        descProd: null,
        excutetime: [],
        wood: null,
        countryFact: null,
        quantatyWanted: null,
        active: null,
        image: {
          path: null,
          file: null,
        },
        nameAr: null,
        nameEn: null,
        region_id: null,
        cleaners: [],
      },
      regions: [],
      // End:: Data Collection To Send
    };
  },

  computed: {
    isMultipleTickets() {
      return String(this.data.ticket_type).toLowerCase() === "multiple";
    },
    hasTickets() {
      return Array.isArray(this.data.tickets) && this.data.tickets.length > 0;
    },
  },

  methods: {
    // start show data
    async showFestivalOrder() {
      try {
        let res = await this.$axios({
          method: "GET",
          url: `festival-orders/${this.$route.params.id}`,
        });
        this.data.status = res.data.data.FestivalOrder?.status;
        this.data.orderNum = res.data.data.FestivalOrder?.serial_number;
        this.data.orderCreate = res.data.data.FestivalOrder?.created_at;
        this.data.status = res.data.data.FestivalOrder?._status;
        this.data.excuteAt = res.data.data.FestivalOrder?.date;
        this.data.excutetime = res.data.data.FestivalOrder.time?.map(
          (ele, index) => ({
            id: index,
            name: ele,
          })
        );
        this.data.unit_name = res.data.data.FestivalOrder?.unit_name;
        this.data.unitSpace = res.data.data.FestivalOrder?.unit_capacity;
        this.data.additions = res.data.data.FestivalOrder?.additions;
        this.data.secret_number = res.data.data.FestivalOrder?.secret_number;
        this.data.serviceName = res.data.data.FestivalOrder?.service_name;
        this.data.servicePrice = res.data.data.FestivalOrder?.service_price;
        this.data.products = res.data.data.FestivalOrder?.order_items;
        this.data.addServices = res.data.data.FestivalOrder?.AdditionServices;
        this.data.totalePrce = res.data.data.FestivalOrder?.order_price;
        this.data.totalTax = res.data.data.FestivalOrder?.tax_value;
        this.data.totalOrderPrice = res.data.data.FestivalOrder?.total;
        this.data.discount = res.data.data.FestivalOrder?.percentage;
        this.data.discountValue = res.data.data.FestivalOrder?.price_percentage;
        this.data.orderPriceAfterDiscount =
          res.data.data.FestivalOrder?.total_amount;
        this.data.PaymentMethods = res.data.data.FestivalOrder?.OrderPayment;
        this.data.back = res.data.data.FestivalOrder?.package_name;
        this.data.cleaners = res.data.data.FestivalOrder?.cleaners;
        this.data.clientName = res.data.data.FestivalOrder?.user?.name;
        this.data.clientPhone = res.data.data.FestivalOrder?.user?.mobile;
        this.data.rate = res.data.data.FestivalOrder?.rate;
        this.data.cancelReason = res.data.data.FestivalOrder?.reason;
        this.data.cancelDate = res.data.data.FestivalOrder?.reason_time;
        this.data.address_details =
          res.data.data.FestivalOrder?.address_details;
        this.data.payment_details =
          res.data.data.FestivalOrder?.payment_details;
        this.data.festival = res.data.data.FestivalOrder?.festival;
        this.data.quantity = res.data.data.FestivalOrder?.quantity;
        this.data.children_count =
          res.data.data.FestivalOrder?.children_count ?? 0;
        this.data.ticket_type = res.data.data.FestivalOrder?.ticket_type;
        this.data.tickets = res.data.data.FestivalOrder?.tickets || [];
        this.data.tickets_count =
          res.data.data.FestivalOrder?.tickets_count ??
          res.data.data.FestivalOrder?.quantity;
        this.data.tickets_new_count =
          res.data.data.FestivalOrder?.tickets_new_count;
        this.data.tickets_used_count =
          res.data.data.FestivalOrder?.tickets_used_count;
        this.data.tickets_expired_count =
          res.data.data.FestivalOrder?.tickets_expired_count;
      } catch (error) {
        this.loading = false;
        console.log(error.response.data.message);
      }
    },
    // end show data
    async getRegions() {
      try {
        let res = await this.$axios({
          method: "GET",
          url: `regions`,
          params: {
            is_active: 1,
          },
        });
        // console.log("Cities =>", res.data.data);
        this.regions = res.data.data;
      } catch (error) {
        console.log(error.response.data.message);
      }
    },
  },

  created() {
    // Start:: Fire Methods
    this.showFestivalOrder();
    // End:: Fire Methods
  },
};
</script>
<style>
.comment {
  border: 1px solid #405950;
  padding: 15px;
  border-radius: 6px;
}
.comment_label {
  color: #405950;
  font-size: 16px;
}

.tickets_table_wrapper {
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  max-height: 360px;
  overflow: auto;
  margin-bottom: 1.5rem;
}

.tickets_table {
  width: 100%;
  border-collapse: collapse;
  min-width: 980px;
}

.tickets_table th,
.tickets_table td {
  padding: 12px 14px;
  text-align: center;
  border-bottom: 1px solid #f0f0f0;
  color: #405950;
  vertical-align: middle;
  white-space: nowrap;
}

.tickets_table thead th {
  position: sticky;
  top: 0;
  background: #f7f7f7;
  font-weight: 700;
  z-index: 1;
}

.tickets_table tbody tr:last-child td {
  border-bottom: none;
}

.ticket_qr_link {
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.ticket_qr_image {
  width: 56px;
  height: 56px;
  object-fit: contain;
  border-radius: 6px;
  background: #fff;
  border: 1px solid #eee;
}
</style>
